import {FC} from "react";
import {PageParts, Vertex} from "../../ducks/types";
import {Box} from "@mui/material";
import {selectImageShapes} from "../../selectors/monitoring";
import {useSelector} from "react-redux";
import {scalePoints} from "../../helper/other";

type PolygonProps = {
    imageId: number; // Массив точек
    pagePart: PageParts;
    rateWidth: number;
    rateHeight: number;
    imageWidth: number;
    imageHeight: number;
}

export const Polygon: FC<PolygonProps> = ({ imageId, pagePart, rateWidth, rateHeight, imageWidth, imageHeight }) => {
    const imagesShape = useSelector(selectImageShapes);

    if(!imagesShape || (imagesShape && (!imagesShape[pagePart] || !imagesShape[pagePart][imageId]))){
        return null;
    }
    const points: Vertex[] = imagesShape[pagePart][imageId];
    // Преобразуем массив точек в строку для атрибута `clip-path`
    const clipPath = `polygon(${scalePoints(points).map(point => `${(point.x * rateWidth * 100)/imageWidth}% ${(point.y * rateHeight * 100)/imageHeight}%`).join(', ')})`;

    return (
        <Box
            sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: `calc(100% - 10px)`,
                height: imageHeight,
                clipPath: clipPath,
                backgroundColor: 'rgba(0, 191, 255, 0.2)', // Полупрозрачный красный цвет
                pointerEvents: 'none', // Чтобы клики проходили через фигуру
            }}
        />
    );
};
